import PropTypes from "prop-types";
import React, { useState } from "react";
import { getAboutus, getCompany } from "../../Services/API/Get";
import LoadingSpinner from "../../components/LoadingSpinner/loadingSpinner";

const SectionTitleWithText = ({ spaceTopClass, spaceBottomClass }) => {

  const [company, setcompany] = useState("");
  const [about, setabout] = useState("");
  const [lopen, setlopen] = useState(false);

  const CompanyGet = () => {
    setlopen(true);
    getCompany()
      .then((res) => {
        setlopen(false);
        console.log(res.data);
        setcompany(res.data[res.data.length - 1]);
        // setLogo(res.data[res.data.length - 1].image)
        // this.setState({
        //   logo: res.data[res.data.length - 1].image,
        // });
      })
      .catch((error) => {
        setlopen(false);
        console.error(error);
      });
  };

  const AboutGet = () => {
    setlopen(true);
    getAboutus()
      .then((res) => {
        setlopen(false);
        console.log("about>>", res.data);
        setabout(res.data[res.data.length - 1]);
        // setLogo(res.data[res.data.length - 1].image)
        // this.setState({
        //   logo: res.data[res.data.length - 1].image,
        // });
      })
      .catch((error) => {
        setlopen(false);
        console.error(error);
      });
  };

  React.useEffect(() => {
    CompanyGet();
    AboutGet();

  }, []);

  return (
    <>
      <LoadingSpinner open={lopen} />
      <div
        className={`welcome-area ${spaceTopClass ? spaceTopClass : ""} ${spaceBottomClass ? spaceBottomClass : ""
          }`}
      >


        <div className="welcome-content text-left">
          <div className="container">
            <div className="row">
              <div className="welcome-content text-left">
                {/* <h5>Who Are We</h5> */}
                <h1>{`FLOOR SWEEPER SERVICE AND REPAIRS`}</h1>
              </div>

              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <p>
                  With a dedicated team of service technicians who will go always go the extra mile for our customers. 
                  We are Melbourne’s leading floor sweeper repair specialists.
                  </p>
                  <p>
                  Wherever you are located in Melbourne, we offer completely affordable tailored and flexible service options 
                  that ensures that your commercial floor sweeper continues to operate in peak condition.
                  </p>
                  <p>

                  We provide premium quality onsite service to hotels, hospitals, institutions and many other sectors. 
                  OZ Rentals delivers preventative maintenance service programs and professional repairs for many well-known brands of floor sweepers.
                  </p>


                </div>
                <div className="col-lg-3 col-md-3">

                  <div
                    className={`single-banner`}
                  >


                    <img src={process.env.PUBLIC_URL + "/assets/img/services/img-1.jpg"} alt="" />


                  </div>


                </div>


              </div>




            </div>


          </div>

          <div className="container">
            <div className="row">
              <div className="welcome-content text-left">
                {/* <h5>Who Are We</h5> */}
                <h1>{`Get Your Floor Sweeper Working Like New Again`}</h1>
              </div>

              <div className="row">
                <div className="col-lg-9 col-md-9">
                  <p>
                  With quick service turnaround times, our professional service technicians will restore your floor sweeper back to its original glory! We 100 percent guarantee you’ll be delighted with us. 
                  that All of our floor sweepers for repair are only handled by our senior team of professional service technicians who have extensive hands-on experience in repairing all brands of sweeper.
                  </p>
                  <p>
                  Our low-cost refurbishment process starts with a comprehensive check of all of the main parts of your sweeper including batteries, hoses, gaskets, brushes, pad drivers, and motor/s and 
                  we replace these parts as required. You need your machinery working at optimum levels to ensure that you achieve the results you need. We’ll do what it takes to make you (and your site) look good!
                  </p>
                  <p>

                  With a strong local reputation for outstanding customer service, we take great pride in our service work. We are confident that you’ll love our level of service and workmanship 
                  in helping your floor sweeper to work as good as new. Just some of the brands that we support include Tennant, Nilfisk, Alto, Clark Equipment, Hako, and many many more.
                  </p>


                </div>
                <div className="col-lg-3 col-md-3">

                  <div
                    className={`single-banner`}
                  >


                    <img src={process.env.PUBLIC_URL + "/assets/img/services/img-2.jpg"} style={{width:"300px", height:"300px"}}  alt="" />


                  </div>


                </div>


              </div>




            </div>


          </div>

        </div>


      </div>
    </>
  );
};

SectionTitleWithText.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string
};

export default SectionTitleWithText;
